export default "__VITE_ASSET__DGfE$9T4__"